<template>
  <div>
    <DialogUpdateEducationPrograms :division="selected" :state="editDivision" />
    <v-btn
      :disabled="!$auth.policies['update-division']"
      class="elevation-0"
      icon
      @click="editDivision = !editDivision"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list>
        <v-list-item @click="onRemove">
          <v-list-item-title :class="{ 'grey--text': !$auth.policies['delete-division'] }">Xóa</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import DialogUpdateEducationPrograms from '../education-programs/DialogUpdateEducationPrograms.vue'

export default {
  components: {
    DialogUpdateEducationPrograms,
  },
  props: {
    selected: { type: Object, default: () => [] },
  },
  data() {
    return {
      sending: null,
      editDivision: false,
    }
  },
  computed: {
    ...mapState('division', ['divisions']),
  },
  methods: {
    ...mapActions('division', ['removeDivision', 'updateDivision']),
    ...mapActions('grade', ['fetchGradesIndependent']),
    ...mapActions({
      fetchAcademics: 'AcademicLevel/fetchAcademics',
      fetchDivisionsWithAcademicLevel: 'division/fetchDivisionsWithAcademicLevel',
    }),
    async refresh() {
      await this.fetchAcademics({})
      await this.fetchDivisionsWithAcademicLevel()
    },
    async onRemove() {
      const grades = await this.fetchGradesIndependent()
      let text = 'Bạn có chắc muốn xóa chương trình đào tạo này?'
      if (Array.isArray(grades) && grades.length) {
        text = `Các học phần liên quan đến chương trình đào tạo này sẽ bị xóa theo. Bạn có chắc chắn muốn xóa chương trình đào tạo này?`
      }
      this.$dialog.confirm({
        title: 'Xóa chương trình đào tạo',
        text,
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          try {
            await this.removeDivision(this.selected.id)
            await this.refresh()
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError()
          }
        },
      })
    },
  },
}
</script>
